<template>
  <div class="dashboard body" v-if="orders.length > 0">
    <el-container>
      <!-- <Aside /> -->

      <el-main>
        <div style="margin-top: -11px; height: 90px; overflow-y: scroll">
          <el-button
            plain
            @click="setSelectedInvoice(index)"
            style="margin-right: 5px; margin-top: 5px"
            v-for="(invoice, index) in orders"
            :key="index"
            :type="selectedIndex == index ? 'warning' : 'success'"
          >
            {{ invoice.receipt.id }}
          </el-button>
          <!-- <el-button
            plain
            type="primary"
            style="margin-right: 5px"
            @click="addNewInvoice"
          >
            <i class="fas fa-plus"></i>
          </el-button> -->
        </div>

        <el-row :gutter="10" class="footer">
          <el-col :xl="5" :lg="5" :md="18" :sm="24">
            <div
              class="bg-White alignment p-3 mt-2"
              v-if="orders[selectedIndex].receipt.items.length > 0"
            >
              <b>
                رقم الفاتورة /
                {{ orders[selectedIndex].receipt.id }}
              </b>
            </div>
          </el-col>
          <el-col :xl="11" :lg="11" :md="18" :sm="24">
            <div
              class="bg-White p-3 mt-2"
              v-if="orders[selectedIndex].receipt.items.length > 0"
            >
              <b>
                العميل /
                {{ orders[selectedIndex].receipt.user.storeName }}
                -
                {{ orders[selectedIndex].receipt.user.address }}
              </b>

              <el-button
                class="mr-2"
                v-if="!orders[selectedIndex].customer_id"
                type="success"
                @click="setCustomerToAdd"
              >
                جديد</el-button
              >
              <el-button
                class="mr-2"
                v-if="!orders[selectedIndex].customer_id"
                type="warning"
                @click="showLinkCustomerModel = true"
              >
                موجود</el-button
              >
            </div>
          </el-col>
          <el-col :xl="8" :lg="8" :md="18" :sm="24">
            <div
              class="bg-White alignment p-3 mt-2"
              v-if="orders[selectedIndex].receipt.items.length > 0"
            >
              <b>
                التوقيت /
                {{
                  orders[selectedIndex].receipt.createdAt
                    | moment("dddd | Do / MM / YYYY | h:mm A")
                }}
              </b>
            </div>
          </el-col>
        </el-row>

        <el-row class="table mt-2 px-3">
          <div
            class="el-table el-table--fit el-table--border el-table--scrollable-y el-table--enable-row-hover el-table--enable-row-transition"
            style="margin-top: 20px; height: 55vh"
          >
            <div class="el-table__header-wrapper">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__header"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="5%" />
                  <col name="el-table_3_column_12" width="33%" />
                  <col name="el-table_3_column_13" width="13%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="7%" />
                  <col name="el-table_3_column_17" width="7%" />
                  <col name="el-table_3_column_18" width="9%" />
                  <!-- <col name="el-table_3_column_19" width="5%" /> -->
                </colgroup>
                <thead class="has-gutter">
                  <tr class="">
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell">#</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                    >
                      <div class="cell">المنتج</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">الوحدة</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell">الكمية</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell">سعر البيع</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell center">الخصم</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                    >
                      <div class="cell center">الإجمالي</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_18 is-leaf"
                    >
                      <div class="cell center">النواقص</div>
                    </th>
                    <!-- <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_18 is-leaf"
                    >
                      <div class="cell center">المتاح</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_19 is-leaf"
                    >
                      <div class="cell"></div>
                    </th> -->
                  </tr>
                </thead>
              </table>
            </div>
            <!-- id="scrollToMe" -->
            <div
              class="el-table__body-wrapper"
              style="height: auto; max-height: 44vh"
              ref="products_table"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__body"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="5%" />
                  <col name="el-table_3_column_12" width="33%" />
                  <col name="el-table_3_column_13" width="13%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="7%" />
                  <col name="el-table_3_column_17" width="7%" />
                  <col name="el-table_3_column_18" width="9%" />
                  <!-- <col name="el-table_3_column_19" width="5%" /> -->
                </colgroup>
                <!-- id="order" -->
                <tbody class="bodytable">
                  <tr
                    class="el-table__row"
                    v-for="(item, index) in orders[selectedIndex].receipt.items"
                    :key="index"
                    :class="item.rejected ? 'strikeout' : ''"
                  >
                    <!-- :class="[
                      item.sale_price < 5 || item.qty < 5 ? 'bg-Red' : '',
                    ]" -->
                    <td
                      :class="
                        item.quantity - item.holdedQty > 0 ? 'bg-danger' : ''
                      "
                      rowspan="1"
                      colspan="1"
                      class="el-table_3_column_11"
                    >
                      <div class="cell">
                        {{ index + 1 }}
                        <el-checkbox
                          v-if="item.canCancel"
                          v-model="item.rejected"
                          @change="changeHold($event, item)"
                        />
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_12">
                      <div class="cell">{{ item.product.name }}</div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_13">
                      <div class="cell">
                        {{ item.product.unit }}
                        <!-- <el-select
                          v-model="form.selected"
                          placeholder="حدد الوحدة"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select> -->
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_14">
                      <div class="cell">
                        {{ item.quantity }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_15">
                      <div class="cell">
                        {{ item.price }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_16">
                      <div class="cell center">
                        {{ item.discountAmount }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_17">
                      <div class="cell center">
                        {{ (item.price - item.discountAmount) * item.quantity }}
                      </div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_18">
                      <div class="cell center">
                        {{ item.quantity - item.holdedQty }}
                      </div>
                    </td>
                    <!-- <td rowspan="1" colspan="1" class="el-table_3_column_18">
                      <div class="cell center">{{ numberToFixed(item.stock) }}</div>
                    </td>
                    <td rowspan="1" colspan="1" class="el-table_3_column_19">
                      <div class="cell">
                        <el-popconfirm
                          confirm-button-text="موافق"
                          cancel-button-text="إلغاء"
                          icon="el-icon-info"
                          icon-color="red"
                          :title="'هل تريد حذف ' + ' ' + item.name + ' ؟'"
                          @confirm="deleteItem(item, index)"
                        >
                          <div slot="reference" class="deleteicon">
                            <i class="fas fa-trash-alt"></i>
                          </div>
                        </el-popconfirm>
                      </div>
                    </td> -->
                  </tr>
                </tbody>
              </table>
              <a id="goToBottom" href="#scrollToMe"></a>
              <div id="scrollToMe"></div>
            </div>
          </div>
        </el-row>
        <el-row :gutter="10" class="footer">
          <el-col :xl="4" :lg="4" :md="18" :sm="24">
            <div
              class="bg-White alignment p-3 mt-2"
              v-if="orders[selectedIndex].receipt.items.length > 0"
            >
              <p>
                الخصم
                <span class="num">{{ totalInvoiceDiscount }}</span>
              </p>
            </div>
          </el-col>
          <el-col :xl="4" :lg="4" :md="18" :sm="24">
            <div
              class="bg-White alignment p-3 mt-2"
              v-if="orders[selectedIndex].receipt.items.length > 0"
            >
              <p>
                الكميه
                <span class="num">{{ totalInvoiceQty }}</span>
              </p>
            </div>
          </el-col>
          <el-col :xl="16" :lg="16" :md="6" :sm="24"
            ><div class="bg-White alignment mt-2">
              <p
                class="px-3"
                v-if="orders[selectedIndex].receipt.items.length > 0"
              >
                اجمالي الفاتوره
                <span>{{ numberToFixed(totalInvoiceCost) }}</span>
              </p>
              <p class="px-3" v-if="totalInvoiceDiscount > 0">
                بعد الخصم
                <span>{{
                  numberToFixed(totalInvoiceCost - totalInvoiceDiscount)
                }}</span>
              </p>
              <el-button
                v-if="orders[selectedIndex].receipt.status == 'pending'"
                class="save"
                :loading="isLoading"
                @click="AcceptOrder"
                >حفظ الفاتوره</el-button
              >
              <!-- @click="showPaymentModal" -->
              <span
                :class="[
                  orders[selectedIndex].receipt.items.length > 0
                    ? ''
                    : 'mr-auto',
                ]"
                class="pl-3"
                v-if="orders[selectedIndex].receipt.status == 'pending'"
              >
                <el-popconfirm
                  confirm-button-text="موافق"
                  cancel-button-text="إلغاء"
                  icon="el-icon-info"
                  icon-color="red"
                  title="هل تريد رفض الفاتورة؟"
                  @confirm="rejectOrder"
                >
                  <div slot="reference">
                    <el-button class="exit mr-3">رفض الفاتورة</el-button>
                  </div>
                </el-popconfirm>
              </span>
              <el-button
                v-if="orders[selectedIndex].receipt.status == 'added'"
                class="save"
                @click="print"
                >طباعة الفاتوره
                <i class="fa fa-print"></i>
              </el-button>
              <span
                :class="[
                  orders[selectedIndex].receipt.items.length > 0
                    ? ''
                    : 'mr-auto',
                ]"
                class="pl-3"
                v-if="orders[selectedIndex].receipt.status == 'added'"
              >
                <el-popconfirm
                  confirm-button-text="موافق"
                  cancel-button-text="إلغاء"
                  icon="el-icon-info"
                  icon-color="red"
                  title="هل تريد إغلاق الفاتورة؟"
                  @confirm="removeSelectedOrder"
                >
                  <div slot="reference">
                    <el-button class="exit mr-3">إغلاق الفاتورة</el-button>
                  </div>
                </el-popconfirm>
              </span>

              <!-- <el-button
                class="save"
                @click="clearStorage"
                >clear storage
                <i class="fa fa-print"></i>
                </el-button> -->
            </div>
          </el-col>
        </el-row>
      </el-main>
      <div v-if="confirmSave == true" class="dialog">
        <div class="bodySec">
          <p @click="confirmSave = false">
            <span><i class="far fa-times-circle"></i></span> اغلاق
          </p>
        </div>
        <div class="content">
          <div class="title">تاكيد توصيل فاتورة T-12 !</div>
          <div class="mt-3">
            <el-radio-group v-model="DeliveryDate" class="radio-block">
              <el-radio
                v-for="(date, i) in deliveryDateOptions"
                :key="i"
                :label="date.value"
                size="medium"
                >{{ date.label }}</el-radio
              ><br />
            </el-radio-group>
            <div style="padding: 10px">
              <el-input
                v-if="DeliveryDate == 'otherDate'"
                v-model="specificDate"
              />
            </div>
          </div>
          <div class="footer">
            <el-button class="with-date" @click="AcceptOrder"
              >تاكيد معاد</el-button
            >
            <!-- <el-button @click="AcceptOrderwithoutdate" class="without-date"
              >استكمال بدون معاد</el-button
            > -->
          </div>
        </div>

        <br />
      </div>
      <el-dialog
        title="تسجيل عميل جديد"
        :visible.sync="addFormVisible"
        v-if="customerForm"
      >
        <el-form :model="customerForm" :rules="rules" ref="customerForm">
          <el-row :gutter="10">
            <el-col :xl="12" :lg="12" :md="6" :sm="12">
              <el-form-item label="الاسم " prop="name">
                <el-input
                  class="formInput1"
                  autofocus
                  v-model="customerForm.name"
                  autocomplete="off"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </el-form-item>
              <!-- @focus="$event.target.select()" -->
            </el-col>
            <el-col :xl="6" :lg="6" :md="12" :sm="12">
              <el-form-item label="رصيد العميل " prop="account">
                <el-input
                  class="formInput2"
                  id="account"
                  type="number"
                  @focus="$event.target.select()"
                  v-model="customerForm.account"
                  controls-position="right"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xl="6" :lg="6" :md="12" :sm="12">
              <el-form-item label="رقم الهاتف " prop="phone">
                <el-input
                  class="formInput3"
                  id="phone"
                  @focus="$event.target.select()"
                  v-model="customerForm.phone"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xl="6" :lg="6" :md="12" :sm="12">
              <el-form-item label="نوع التسعير " prop="price_type">
                <el-select
                  id="priceType"
                  @change="focusNext"
                  @focus="$event.target.select()"
                  class="formInput4"
                  v-model="customerForm.price_type"
                  clearable
                  placeholder=" نوع التسعير"
                  style="width: 100%"
                >
                  <el-option label="جمله" value="2"> </el-option>
                  <el-option label="جملة الجملة" value="1"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xl="18" :lg="18" :md="24" :sm="24">
              <el-form-item label="العنوان  " prop="address">
                <el-input
                  class="formInput5"
                  id="address"
                  @focus="$event.target.select()"
                  v-model="customerForm.address"
                  @keyup.enter.native="focusNext"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" plain @click="addNewCustomer"
            >تسجيل العميل
          </el-button>
          <el-button class="mr-3" @click="addFormVisible = false"
            >إلغاء</el-button
          >
        </span>
      </el-dialog>
      <el-dialog title="ربط العميل" :visible.sync="showLinkCustomerModel">
        <SearchCustomers
          ref="searchCustomersComponent"
          :customer="orders[selectedIndex].customer"
          @selectedCustomer="selectedCustomer"
          :productSearch="false"
          :searchOnly="true"
          :showLabel="true"
          :productsLength="0"
        />
        <el-button
          type="success"
          class="save mr-3"
          @click="showLinkCustomerModel = false"
          >ربط العميل
          <i class="fa fa-link"></i>
        </el-button>
      </el-dialog>
      <!-- <PrintSaleInvoice :invoice_details="invoice_details" /> -->
    </el-container>
  </div>
</template>

<script>
import Aside from "@/components/aside.vue";
import { mapGetters, mapActions } from "vuex";
import SearchCustomers from "@/components/Customers/Search";
// import { ipcRenderer } from "electron";
import axiosApi from "@/plugins/axios.js";

let today = new Date();
let tomorrow = new Date(
  today.getFullYear(),
  today.getMonth(),
  today.getDate() + 1
);
let afterTomorrow = new Date(
  today.getFullYear(),
  today.getMonth(),
  today.getDate() + 2
);

export default {
  components: { Aside, SearchCustomers },
  name: "Dashboard",
  data: () => ({
    true: true,
    loadingStart: true,
    totalInvoiceCost: 0,
    totalInvoiceCredit: 0,
    totalInvoiceQty: 0,
    totalInvoiceDiscount: 0,
    invoice_details: null,
    selectedIndex: 0,
    showLinkCustomerModel: false,
    addFormVisible: false,
    confirmSave: false,
    isLoading: false,
    index: 1,
    DeliveryDate: today.toLocaleDateString().replace(/\//gi, "-"),
    specificDate: "",
    rules: {
      name: [{ required: true, message: "حدد اسم العميل", trigger: "blur" }],
      account: [
        { required: true, message: "حدد الرصيد الافتتاحي", trigger: "blur" },
      ],
      address: [{ required: true, message: "حدد العنوان ", trigger: "blur" }],
      price_type: [
        { required: true, message: "حدد سياسة التسعير ", trigger: "blur" },
      ],
      phone: [
        { required: true, message: "حدد رقم الهاتف", trigger: "blur" },
        { min: 11, max: 11, message: "حدد رقم هاتف صحيح", trigger: "change" },
      ],
    },
    customerForm: {
      name: "",
      type: 1,
      price_type: "",
      inventory_id: 1,
      area: 1,
      phone: "",
      account: 0,
      supplier_account: 0,
      address: "",
    },
    // deliveryDateOptions: [
    //   {label: "نفس اليوم", value: today.toLocaleDateString().replace(/\//gi,"-")},
    //   {label: "غدا (خلال 24 ساعه)", value: tomorrow.toLocaleDateString().replace(/\//gi,"-")},
    //   {label: "بعد الغد (خلال 48 ساعه)", value: afterTomorrow.toLocaleDateString().replace(/\//gi,"-")},
    //   {label: "موعد اخر", value: "otherDate"}
    // ]
    deliveryDateOptions: [
      { label: "نفس اليوم", value: "2021-12-3" },
      {
        label: "غدا (خلال 24 ساعه)",
        value: tomorrow.toLocaleDateString().replace(/\//gi, "-"),
      },
      {
        label: "بعد الغد (خلال 48 ساعه)",
        value: afterTomorrow.toLocaleDateString().replace(/\//gi, "-"),
      },
      { label: "موعد اخر", value: "otherDate" },
    ],
  }),
  computed: mapGetters(["orders"]),
  watch: {
    setPaied: function () {
      this.sales[this.selectedIndex].paied = 0;
      setTimeout(() => {
        document.getElementById("paied").focus();
      }, 100);
    },

    // selectedIndex: function (newValue, oldValue) {
    //   if (newValue != oldValue) {
    //     if (this.sales[newValue].customer != null) {
    //       this.customer = this.sales[newValue].customer;
    //     } else {
    //       this.customer = null;
    //     }
    //     this.checkOrderStock();

    //     this.$refs.searchCustomersComponent.setValue(this.customer);
    //   }
    // },
  },
  created() {
    this.calcFaturaInvoice();
    // axiosApi.get("all-order").then((orders)=>{
    //   console.log(orders);
    // })
  },
  mounted() {
    this.scrollToEnd();
  },
  methods: {
    ...mapActions(["setOrders"]),
    clearStorage() {
      this.faturaInvoices = [];
      this.setOrders([]);
    },
    setCustomerToAdd() {
      this.customerForm.name = this.orders[
        this.selectedIndex
      ].receipt.user.storeName;
      this.customerForm.phone = this.orders[
        this.selectedIndex
      ].receipt.user.phone;
      this.customerForm.address = this.orders[
        this.selectedIndex
      ].receipt.user.address;
      this.addFormVisible = true;
    },
    selectedCustomer(e) {
      this.orders[this.selectedIndex].customer_id = e.customer.id;

      this.setOrders(this.orders);
      // this.getCustomerAccount();
    },
    addNewCustomer() {
      this.$refs["customerForm"].validate((valid) => {
        if (valid) {
          axiosApi
            .post("customers", this.customerForm)
            .then((res) => {
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات العميل بنجاح",
                type: "success",
                duration: 1500,
              });

              this.addFormVisible = false;
              this.orders[this.selectedIndex].customer_id = res.data.id;

              this.setOrders(this.orders);
              this.index = 1;
              this.$refs["customerForm"].resetFields();
            })
            .catch(() => {
              this.$notify({
                title: "حدث خطأ",
                message: "عفوا رقم الهاتف مستخدم لحساب اخر ",
                type: "error",
                duration: 1500,
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    removeSelectedOrder() {
      this.orders.splice(this.selectedIndex, 1);
      this.setOrders(this.orders);
      if (this.selectedIndex > 0) {
        this.selectedIndex--;
      } else {
        this.$router.push({ path: "/sales" });
      }
    },
    calcFaturaInvoice() {
      // alert("dddddd");
      if (this.orders.length > 0) {
        // let vm = this;
        this.totalInvoiceCost = 0;
        this.totalInvoiceDiscount = 0;
        this.totalInvoiceCredit = 0;
        this.totalInvoiceQty = 0;
        let sumCost = 0;
        let sumDiscount = 0;
        let sumCredit = 0;
        let sumQty = 0;
        // alert("calc")
        this.orders[this.selectedIndex].expectedDeliveryDate = "";
        this.orders[this.selectedIndex].receipt.items.map((item) => {
          if (!item.rejected) {
            // console.log(item.price ,item.discountAmount, item.quantity)
            item["accept"] = true;
            item["canCancel"] = true;
            // console.log(item.price)
            sumCost += item.price * item.holdedQty;
            sumDiscount += item.discountAmount * item.holdedQty;
            sumCredit += item.creditAmount * item.holdedQty;
            sumQty += item.holdedQty;

            console.log("--------", sumCost, "----------------");
          }
        });

        this.totalInvoiceCost += sumCost;
        this.totalInvoiceDiscount += sumDiscount;
        this.totalInvoiceCredit += sumCredit;
        this.totalInvoiceQty += sumQty;
      }
    },
    validateQty() {
      // if(this.qty==0||this.qty==""){
      //   this.qty=1;
      // }

      if (
        this.qty <= this.selectedProductStock &&
        this.qty > 0 &&
        this.qty != ""
      ) {
        this.showQtyToolTip = false;
        this.setPriceFocus();
      } else {
        this.showQtyToolTip = true;
      }
    },
    focusNext() {
      if (this.index < 5) {
        this.index += 1;
      } else {
        this.index = 1;
      }
      let input = ".formInput" + this.index + " input";
      setTimeout(() => {
        document.querySelector(input).focus();
      }, 100);
    },
    setSelectedInvoice(index) {
      this.selectedIndex = index;
      this.calcFaturaInvoice();
      // this.customer = this.sales[index].customer;
      // if (this.sales[index].customer != null) {
      //   document.querySelector(".productQuery input").focus();
      // } else {
      //   document.querySelector(".customerQuery input").value = "";
      //   document.querySelector(".customerQuery input").focus();
      // }
      //   document.querySelector(".productQuery input").placeholder="";
      // this.clearProduct();
    },
    showPaymentModal() {
      // ! get customer info to display balance

      this.confirmSave = true;
    },
    print() {
      // window.ipcRenderer = ipcRenderer;
      let data = {
        data: this.orders[this.selectedIndex].invoice_details,
        type: "saleInvoice",
        title: "مبيعات",
        invoiceType: "sales",
        img:
          "https://pos.staging.fatura-app.com" +
          JSON.parse(localStorage.getItem("branch")).logo,
      };
      console.log("🚀 ~ print ~ data:", data)
      // ipcRenderer.send("printing", data);
    },
    AcceptOrder() {
      // ! Get customer for invocie faturaId
      // ! If exist then link it with customer_id
      // ! Else show modal with  fatura user detials to store as new user
      // ! Allow to select from current customers and link it with faturaId
      if (this.orders[this.selectedIndex].customer_id != null) {
        this.orders[this.selectedIndex].expectedDeliveryDate = "1";
        // if (this.DeliveryDate == "otherDate") {
        //   this.orders[
        //     this.selectedIndex
        //   ].expectedDeliveryDate = this.specificDate;
        // }
        if (this.orders[this.selectedIndex].receipt.items.length > 0) {
          this.isLoading = true;
          const loading = this.$loading({
            lock: true,
            text: "جاري تحميل الفاتورة",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.orders[this.selectedIndex].inventory_id = 1;
          axiosApi
            .post("sales/fatura", this.orders[this.selectedIndex])
            .then((res) => {
              console.log("===== Saved fatura invoice ======", res.data);
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات الفاتورة بنجاح",
                type: "success",
                duration: 1500,
              });
              this.orders[this.selectedIndex].invoice_details =
                res.data.invoice[0];
              this.orders[this.selectedIndex].receipt.status = "added";
              this.setOrders(this.orders);
              this.confirmSave = false;
            })
            .catch(() => {
              this.$notify.error({
                title: "حدث خطأ",
                message: "عفوا تأكد من بيانات الفاتورة",
                duration: 1500,
              });
            })
            .finally(() => {
              loading.close();
              this.isLoading = false;
            });
        }
      } else {
        this.$notify.error({
          title: "حدث خطأ",
          message: "عفوا تأكد من تسجيل العميل",
          duration: 1500,
        });
      }
    },
    AcceptOrderwithoutdate() {
      if (this.orders[this.selectedIndex].customer_id != null) {
        this.orders[this.selectedIndex].expectedDeliveryDate = "";
        if (this.orders[this.selectedIndex].receipt.items.length > 0) {
          this.isLoading = true;
          const loading = this.$loading({
            lock: true,
            text: "جاري تحميل الفاتورة",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.orders[this.selectedIndex].inventory_id = 1;
          axiosApi
            .post("sales/fatura", this.orders[this.selectedIndex])
            .then((res) => {
              console.log("===== Saved fatura invoice ======", res.data);
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات الفاتورة بنجاح",
                type: "success",
                duration: 1500,
              });
              this.orders[this.selectedIndex].invoice_details =
                res.data.invoice[0];
              this.orders[this.selectedIndex].receipt.status = "added";
              this.setOrders(this.orders);
              this.confirmSave = false;
            })
            .catch(() => {
              this.$notify.error({
                title: "حدث خطأ",
                message: "عفوا تأكد من بيانات الفاتورة",
                duration: 1500,
              });
            })
            .finally(() => {
              loading.close();
              this.isLoading = false;
            });
        }
      } else {
        this.$notify.error({
          title: "حدث خطأ",
          message: "عفوا تأكد من تسجيل العميل",
          duration: 1500,
        });
      }
    },
    rejectOrder() {
      // ! Get customer for invocie faturaId
      // ! If exist then link it with customer_id
      // ! Else show modal with  fatura user detials to store as new user
      // ! Allow to select from current customers and link it with faturaId
      if (this.orders[this.selectedIndex].receipt.items.length > 0) {
        this.isLoading = true;
        const loading = this.$loading({
          lock: true,
          text: "جاري تحميل الفاتورة",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        // this.orders[this.selectedIndex].customer_id=1;
        this.orders[this.selectedIndex].inventory_id = 1;
        axiosApi
          .get(
            `sales/reject-fatura/${this.orders[this.selectedIndex].receipt.id}`
          )
          .then(() => {
            this.$notify({
              title: "تمت العملية بنجاح",
              message: "تم رفض الفاتورة بنجاح",
              type: "success",
              duration: 1500,
            });

            axiosApi
              .post(`products/un-hold-fatura`, {
                products: this.orders[this.selectedIndex].receipt.items,
                inventory_id: JSON.parse(
                  localStorage.getItem("user_inventories")
                )[0].id,
              })
              .then(() => {
                this.removeSelectedOrder();
              });
          })
          .catch(() => {
            this.$notify.error({
              title: "حدث خطأ",
              message: "عفوا تأكد من بيانات الفاتورة",
              duration: 1500,
            });
          })
          .finally(() => {
            loading.close();
            this.isLoading = false;
          });
      }
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    scrollToEnd() {
      setTimeout(() => {
        let elementToScrollDown = this.$refs.products_table;
        elementToScrollDown.scrollTop = elementToScrollDown.scrollHeight;
      }, 300);
      console.log("scrollToEnd");

      // this.$el.querySelector("#goToBottom").click();
    },
    changeHold(e, item) {
      let url = "products/hold-fatura";
      let product = { ...item };
      if (e == true) {
        url = `products/un-hold-fatura`;
        product.rejected = false;
      }
      axiosApi
        .post(url, {
          products: [product],
          inventory_id: JSON.parse(localStorage.getItem("user_inventories"))[0]
            .id,
        })
        .then(() => {
          this.setOrders(this.orders);
          this.calcFaturaInvoice();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
#scrollToMe {
  overflow-y: scroll;
}
tr.strikeout td:before {
  content: " ";
  position: absolute;
  top: 50%;
  left: 0;
  border-bottom: 1px solid red !important;
  width: 100%;
}
.dialog .content {
  padding: 0;
  width: 281px;
}
.dialog .content::after {
  display: none;
}
.dialog .content .title {
  text-align: center;
  background-color: #f6f6f6;
  font-weight: bold;
}
.radio-block {
  flex-direction: column;
}
.radio-block .el-radio {
  margin-right: 10px;
  margin-bottom: 16px;
}
.dialog .content .footer {
  display: flex;
  justify-content: space-between;
}
.with-date {
  color: #67c23a;
  border: none;
}
.with-date:hover {
  color: #67c23a;
  border-color: transparent;
  background-color: transparent;
}
.without-date {
  color: #f56c6c;
  border: none;
}
.without-date:hover {
  color: #f56c6c;
  border-color: transparent;
  background-color: transparent;
}
</style>
<style>
.el-radio__input.is-checked .el-radio__inner {
  border-color: #ffcc00 !important;
  background: #ffcc00 !important;
}
.el-radio__label {
  color: #000 !important;
  padding-right: 5px;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #ffcc00 !important;
  background: #ffcc00 !important;
}
</style>
